import commonMapping from "@/mapping/common";

const security_type_list = [
  {
    id: "security_disable",
    value: "Disable",
    label: "sec_off",
    config: "None",
  },
  {
    id: "security_wpa2",
    value: "WPA2-PSK",
    label: "sec_wpa2",
    config: "WPA2-Personal",
  },
  {
    id: "security_auto",
    value: "AUTO-PSK",
    label: "sec_wpas",
    config: "WPA-Personal+WPA2-Personal",
  },
  {
    id: "security_wpa_enter",
    value: "WPA2-Enterprise",
    label: "sec_wpa_enterprise",
    config: "WPA2-Enterprise",
  },
  {
    id: "security_wpa3",
    value: "WPA3-PSK",
    label: "WPA3-Personal",
    config: "WPA3-Personal",
  },
];

const security_type_an_list = [
  {
    id: "security_an_disable",
    value: "Disable",
    label: "sec_off",
    config: "None",
  },
  {
    id: "security_an_wpa2",
    value: "WPA2-PSK",
    label: "sec_wpa2",
    config: "WPA2-Personal",
  },
  {
    id: "security_an_auto",
    value: "AUTO-PSK",
    label: "sec_wpas",
    config: "WPA-Personal+WPA2-Personal",
  },
  {
    id: "security_an_wpa_enter",
    value: "WPA2-Enterprise",
    label: "sec_wpa_enterprise",
    config: "WPA2-Enterprise",
  },
  {
    id: "security_an_wpa3",
    value: "WPA3-PSK",
    label: "WPA3-Personal",
    config: "WPA3-Personal",
  },
];

const wpa_mode_list = [
  {
    value: "WPAE-AES",
    config: "WPAE-AES",
    label: "WPA2 [AES]",
  },
  {
    value: "WPAE-TKIPAES",
    label: "WPA [TKIP] + WPA2 [AES]",
    config: "WPAE-TKIPAES",
  },
];

export const wireless = {
  region: commonMapping.regionList,
  lbd_enable: commonMapping.intToBoolean,
  ax_enable: commonMapping.intToBoolean,
  ofdma_enable: commonMapping.intToBoolean,
  ofdma5g_enable: commonMapping.intToBoolean,
  endis_ssid_broadcast: commonMapping.intToBoolean,
  obss_coex_enable: commonMapping.intToBoolean,
  security_type: security_type_list,
  wpa_mode: wpa_mode_list,
  wla_endis_ssid_broadcast_an: commonMapping.intToBoolean,
  security_type_an: security_type_an_list,
  wpa_mode_an: wpa_mode_list,
};

export default wireless;
